<ng-container *ngIf="mainImage$ | async as main">
  <cx-media [container]="main"> </cx-media>
  <u class="enlargeImg pl-1 pt-2 pb-4" (click)="enlargeImg(main?.zoom?.url)">Click Image to Enlarge</u>
</ng-container>

<ng-container *ngIf="thumbs$ | async as thumbs">
  <cx-carousel
    *ngIf="thumbs.length"
    class="thumbs"
    [items]="thumbs"
    itemWidth="120px"
    [hideIndicators]="false"
    [template]="thumb"
  ></cx-carousel>
</ng-container>

<ng-template #thumb let-item="item">
  <cx-media
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
  >
  </cx-media>
</ng-template>
